import { render, staticRenderFns } from "./FacebookLogo.vue?vue&type=template&id=2ba177ca&scoped=true"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba177ca",
  null
  
)

export default component.exports